export default {
  sections: {
    payment: 'Płatność',
  },
  labels: {
    proceed_to_payment: 'Przejdź do płatności przez link lub zeskanuj kod QR',
  },
  buttons: {
    generate_new_link: 'Generuj nowy link',
    copy_link: 'Kopiuj link',
    pay_now: 'Zapłać teraz',
  },
  toasts: {
    failed_to_create_payment_link: 'Nie udało się załadować linku do płatności',
  },
};
